if (!customElements.get('card-variant-picker')) {
  customElements.define(
    'card-variant-picker',
    class CardVariantPicker extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector('select');
        this.card = this.closest('.card-wrapper');

        if (!this.select || !this.card) return;

        this.select.addEventListener('change', this.onVariantChange.bind(this));
      }

      onVariantChange() {
        const option = this.select.options[this.select.selectedIndex];
        if (!option) return;

        const variantUrl = option.dataset.variantUrl;
        const priceValue = Number(option.dataset.priceValue || 0);
        const comparePriceValue = Number(option.dataset.comparePriceValue || 0);
        const isAvailable = option.dataset.available === 'true';

        this.updateLinks(variantUrl);
        this.updateQuickAdd(variantUrl);
        this.updatePrice(option, priceValue, comparePriceValue, isAvailable);
      }

      updateLinks(variantUrl) {
        if (!variantUrl) return;

        this.card.querySelectorAll('.full-unstyled-link').forEach((link) => {
          link.href = variantUrl;
        });
      }

      updateQuickAdd(variantUrl) {
        if (!variantUrl) return;

        this.card.querySelectorAll('[data-product-url]').forEach((button) => {
          button.setAttribute('data-product-url', variantUrl);
        });

        this.card.querySelectorAll('input.product-variant-id').forEach((input) => {
          input.value = this.select.value;
        });
      }

      updatePrice(option, priceValue, comparePriceValue, isAvailable) {
        const price = this.card.querySelector('.card-information > .price');
        if (!price) return;

        const regularPrice = price.querySelector('.price__regular .price-item--regular');
        const salePrice = price.querySelector('.price__sale .price-item--sale');
        const comparePrice = price.querySelector('.price__sale s.price-item--regular');
        const isOnSale = comparePriceValue > priceValue;

        price.classList.toggle('price--on-sale', isOnSale);
        price.classList.toggle('price--sold-out', !isAvailable);

        if (regularPrice) regularPrice.textContent = option.dataset.price;
        if (salePrice) salePrice.textContent = option.dataset.price;
        if (comparePrice) comparePrice.textContent = option.dataset.comparePrice || '';
      }
    }
  );
}
